import React from "react";
import "./About_Us.css";
import Choose_Us from "./choose_us/Choose_Us";
import Mission_Vision from "./mission_vision/Mission_Vision";
import Common_Banner from "../common-components/common-banner/Common_Banner";
import { Container } from "react-bootstrap";
import All_activities from "./all_activities/All_activities";

const About_Us = () => {
  const breadcrumbs = [
    { label: "Home", link: "/about-us", isActive: false },
    { label: "ABOUT US", link: "", isActive: true },
  ];

  return (
    <section className="About_Us">
      <Common_Banner
        imgSrc={"/assets/images/common_banners/about_banner.png"}
        title_text="About Us"
        breadcrumbs={breadcrumbs}
      />

      <div className="about_bg_img_holder">
        <section className="about-section">
          <Container>
            <div className="about-text">
              <p className="text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non
                risus. Suspendisse lectus tortor, dignissim sit amet, adipiscing
                nec, ultricies sed, dolor. Cras elementum ultrices diam.
                Maecenas ligula massa, varius a, semper congue, euismod non, mi.
                Proin porttitor, orci nec nonummy molestie, enim est eleifend
                mi, non fermentum diam nisl sit amet erat. Duis semper. Duis
                arcu massa, scelerisque vitae, consequat in, pretium a, enim.
                Pellentesque congue. Ut in risus volutpat libero pharetra
                tempor. Cras vestibulum bibendum augue. Praesent egestas leo in
                pede. Praesent blandit odio eu enim. Pellentesque sed dui ut
                augue blandit sodales. Vestibulum ante ipsum primis in faucibus
                orci luctus et ultrices posuere cubilia Curae; Aliquam nibh.
                Mauris ac mauris sed pede pellentesque fermentum. Maecenas
                adipiscing ante non diam sodales hendrerit.
              </p>
            </div>
          </Container>
        </section>

        <Mission_Vision />
        <All_activities />
        <Choose_Us />
      </div>
    </section>
  );
};

export default About_Us;
